import React from "react";
import { Patient } from "../Card/props";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: Patient[];
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, content }) => {
  if (!isOpen) return null;

  const handlePrint = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    if (printWindow) {
      printWindow.document.write('<html><head><title>Print</title>');
      printWindow.document.write('</head><body>');
      printWindow.document.write(document.getElementById('print-content')!.innerHTML);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50 mt-20">
      <div className="relative bg-white rounded-lg shadow-lg p-6 max-w-lg w-full overflow-y-auto" style={{ maxHeight: '80vh' }}>
        <button
          className="absolute top-4 right-4"
          onClick={onClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Today's Pharmacy Report</h2>
        <div id="print-content">
          {content.length > 0 ? content.map((patient, index) => (
            <div key={index} className="mb-8 p-4 border rounded-lg shadow-md bg-gray-50">
              <h3 className="text-xl font-semibold text-gray-800">{patient.patientName}</h3>
              <p className="text-sm text-gray-600 mb-2">ICO NO: <span className="font-medium">{patient.icoNO}</span></p>
              {patient.records.map((record, recordIndex) => (
                <div key={recordIndex} className="mb-4 p-2 border-t border-gray-300">
                  <h4 className="text-md font-medium mb-2 text-gray-700">Date: <span className="font-semibold">{record.date}</span></h4>
                  <div className="grid grid-cols-1 gap-4">
                    {record.injections.length > 0 && (
                      <div className="mb-2">
                        <h5 className="font-semibold text-lg">Injections:</h5>
                        <ul className="list-disc ml-5">
                          {record.injections.map((item, i) => (
                            <li key={i} className="text-gray-600">{item.name} - ₹{item.price}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {record.medicines.length > 0 && (
                      <div className="mb-2">
                        <h5 className="font-semibold text-lg">Medicines:</h5>
                        <ul className="list-disc ml-5">
                          {record.medicines.map((item, i) => (
                            <li key={i} className="text-gray-600">{item.name} - ₹{item.price}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {record.surgicals.length > 0 && (
                      <div className="mb-2">
                        <h5 className="font-semibold text-lg">Surgicals:</h5>
                        <ul className="list-disc ml-5">
                          {record.surgicals.map((item, i) => (
                            <li key={i} className="text-gray-600">{item.name} - ₹{item.price}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {record.anaesthetics.length > 0 && (
                      <div className="mb-2">
                        <h5 className="font-semibold text-lg">Anaesthetics:</h5>
                        <ul className="list-disc ml-5">
                          {record.anaesthetics.map((item, i) => (
                            <li key={i} className="text-gray-600">{item.name} - ₹{item.price}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )) : <p className="text-center text-gray-600">No data available</p>}
        </div>
        <div className="flex justify-between mt-6">
          <button
            onClick={handlePrint}
            className={`bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition duration-300 ${content.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={content.length === 0}
          >
            Print
          </button>
          <button
            onClick={onClose}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition duration-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
